import React from 'react';
import OutreachSection from 'components/Enterprise/OutreachSection';

type ContentWithImage = {
  heading: string;
  description: {
    description: string;
  };
  image: {
    description: string;
    fluid: {
      src: string;
    };
  };
};

export interface OutreachContainerProps {
  content: {
    title: string;
    headline: string;
    subHeadline: string;
    listOfContentWithImages: ContentWithImage[];
  };
}
// TODO replace this with a real component or assemblage of components - this is placeholder

export const OutreachContainer: React.FC<OutreachContainerProps> = ({
  content,
}) => {
  if (!content) {
    return null;
  }

  const { title, headline, subHeadline, listOfContentWithImages } = content;

  const formattedListOfContent = listOfContentWithImages.map(item => ({
    heading: item.heading,
    description: item.description.description,
    imageSrc: item?.image?.fluid?.src,
    imageAlt: item?.image?.description,
  }));

  return (
    <OutreachSection
      title={title}
      headline={headline}
      subheadline={subHeadline}
      listOfContent={formattedListOfContent}
    />
  );
};

export default OutreachContainer;
